import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import React, { VFC } from 'react';
import { PayrollFileDetails, PayrollVopResult } from '../../../domain/Payroll/entities/types';
import { TableGrid } from '../../../../../content-composer/src/components/Generic/TableGrid';
import { ContentWrapper } from '../../../../../content-composer/src/components/Generic/ContentWrapper';
import { usePayrollDetailsGridConfig } from './usePayrollDetailsGridConfig';
import { usePayrollDetailsVopGridConfig } from './usePayrollDetailsVopGridConfig';

export interface PayrollDetailsDrawerTableProps {
  payrollFilesDetailsList: PayrollFileDetails[];
  isLoading: boolean;
  error?: any;
  hasVOP?: boolean;
  vopPayrolls?: PayrollVopResult[];
  selectedVopPayrolls?: PayrollVopResult[];
  setSelectedVopPayrolls?: (payrolls: PayrollVopResult[]) => void;
  onClickRetry?: () => void;
}

const PayrollDetailsDrawerTable: VFC<PayrollDetailsDrawerTableProps> = ({
  payrollFilesDetailsList,
  isLoading,
  hasVOP,
  vopPayrolls,
  selectedVopPayrolls,
  setSelectedVopPayrolls,
  onClickRetry,
}) => {
  const configDetails = usePayrollDetailsGridConfig();
  const configVopDetails = usePayrollDetailsVopGridConfig({
    payrolls: vopPayrolls || [],
    selectedPayrolls: selectedVopPayrolls || [],
    setSelectedPayrolls: setSelectedVopPayrolls || (() => {}),
    onClickRetry: onClickRetry || (() => {}),
  });
  const config = hasVOP ? configVopDetails : configDetails;
  const shouldShowTable = hasVOP ? !isEmpty(vopPayrolls) : !isEmpty(payrollFilesDetailsList);

  return (
    <>
      <ContentWrapper paperProps={{ style: { padding: 0 } }} boxProps={{ padding: 0 }}>
        {shouldShowTable && (
          <TableGrid
            gridOptions={config.gridOptions}
            columnDefs={config.columnDefs}
            rowData={hasVOP ? vopPayrolls : payrollFilesDetailsList}
            hasSkeleton={isLoading}
            mobileListConfig={config.mobileListConfig}
          />
        )}
      </ContentWrapper>
    </>
  );
};

export { PayrollDetailsDrawerTable };
